<template>
  <div>
    <div v-if="!dataloaded || !userDataLoaded" class="blackbox-loader"></div>

    <v-container v-if="dataloaded && userDataLoaded"  grid-list-md class="ma-0 pa-2" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12 v-if="companies.length > 1 && !this.demoMode">
          <v-select
            class="ma-1"
            :items="filteredCompanies"
            :color="companyPrimaryColor"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"    
            item-text="name"
            item-value="id"
            v-on:input="loadComplainFormData()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            hide-details
            dense>
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
        <v-flex  md9 xs12>

        </v-flex>
      </v-layout>
    </v-container>

    <div v-if="dataloaded && userDataLoaded && !deleting && complains.length > 0" class="mt-5">
      <div class="content-box">
        <v-card>
          <v-card-title>
            <v-text-field
              style="max-width: 300px;"
              v-model="search"
              :color="companyPrimaryColor"
              placeholder="Zoeken"
              outlined
              dense
              hide-details     
              background-color="#fff"                                                
              prepend-inner-icon="search"
              autocomplete="disabled"
              clearable>
            </v-text-field>
            <v-spacer></v-spacer>
            <div class="header-edit-button">
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" fab darken color="primary" @click="addNewComplain()">
                    <v-icon darken>add</v-icon>
                  </v-btn>
                </template>
                <span style="color: #fff;">Nieuwe klacht</span>
              </v-tooltip>
            </div>
          </v-card-title>

          <v-data-table
            :headers="headerscomplains"
            :items="complains"
            :search="search"
            :itemsPerPage.sync="queuePages"
            v-model="selected"
            hide-default-footer
            :no-results-text="`Geen resultaten gevonden voor: ${search}`"
            >
            <template v-slot:item="{item}">
              <tr >
                <td class="text-xs-left">{{ item.date | moment("DD-MM-YYYY") }}</td>
                <td class="text-xs-left">{{ item.firstName}} {{ item.lastName}}</td>
                <td class="text-xs-left">{{ getBranchName(item.branch)}}</td>
                <td class="text-xs-left"> <v-chip small v-for="(complain,i) in item.complain" :key="i" class="mr-1 mb-1">{{ getComplainName(complain) }}</v-chip> </td>
                <td class="text-right">
                  <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" icon small @click="deleteComplainDialog(item)"><v-icon>mdi-delete</v-icon></v-btn>
                  <v-btn icon small @click="viewComplain(item)"><v-icon>mdi-eye</v-icon></v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </div>

    <div style="width: 350px; margin: 50px auto;" class="text-center" v-if="dataloaded && userDataLoaded && !deleting && complains.length == 0">
      <p>Er zijn nog geen klachten.</p>
      <div class="text-center">
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" fab darken color="primary" style="display: block; margin: 15px auto;" @click="addNewComplain()">
              <v-icon darken>add</v-icon>
            </v-btn>
          </template>
          <span style="color: #fff;">Voeg een nieuwe klacht toe.</span>
        </v-tooltip>
      </div>
    </div>

    <!-- / Complain Dialog \ -->
    <complain-form :activeCompData="activeCompData" :branches="branches" @updateData="updateData()"></complain-form>
    <!-- \ Complain  Dialog / -->

      <!-- / Delete Dialog \-->
  <v-dialog v-model="removeComplainData.dialog" max-width="450">
      <v-card>
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 class="white--text">Klacht verwijderen</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeRemoveComplain()">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <div class="pt-4 text-center">Klacht definitief verwijderen? Dit kan niet meer hersteld worden.</div>
        </v-card-text>
        
        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  color="#8B93A6"
                  @click="closeRemoveComplain()"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  dark
                  rounded
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companySecondaryColor"
                  @click="deleteMembership()"
                  >
                  Verwijderen
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-- \ Delete Dialog / -->

  </div>
</template>



<script>
  import { bus } from "../main";
  import db from "../firebase/init";
  import _lodash from "lodash";
  import platform from 'platform'; 
  import moment from 'moment';
  import ComplainForm from "../components/modals/AddComplainForm.vue";

  export default {
    name: "complain",
    components: {
    "complain-form": ComplainForm,
  },
    data: () => ({
      activeComp: null,
      activeCompData: null,
      userDataLoaded: false,
      selectedBranchesOriginal: [],
      selectedBranches: [],
      selectedBranchesData: [],
      search: "",
      searchCompanies: "",
      selected: [],
      deleting: false,
      deleteCounter: 0,
      dataloaded: false,
      newQueueDialog: false,
      editQueueDialog: false,
      pagination: {
        rowsPerPage: "200",
        sortBy: "dateAdded.seconds",
        descending: false
      },
      headerscomplains: [
        { text: "Datum", value: "timestamp", sortable: true, align: "left", width: "180px" },
        { text: "Naam", value: "clientName", sortable: false, width: "200px" },
        { text: "Vestiging", value: "branch", sortable: false, width: "200px"  },
        { text: "Klacht(en)", value: "complain", sortable: false },
        { text: "", value: "edit", sortable: false, width: "150px" }
      ],
      loaderSearch: false,
      zoekSalonhubClient: null,
      complainDateDialog: false,
      searchResultsSalonhub: new Array(),
      complains: [],
      membershipsScheduled: [],
      selectedClientQueueItemOriginal: {},
      removeBookings: "",
      selected: [],
      branches: [],
      companies: [],
      queuePages: -1,

      headers: [
        {
          text: "Datum",
          align: "left",
          value: "dateAdded",
          width: "200px"
        },
        {
          text: "Type",
          align: "left",
          value: "type",
          width: "200px"
        },
        {
          text: "Naam",
          align: "left",
          value: "lastName"
        },
        {
          text: "Vestiging",
          align: "left",
          value: "branch"
        },
        {
          text: "Bedrag",
          align: "left",
          value: "firstName"
        },
        {
          text: "Download",
          align: "left",
          value: "firstName"
        },
        {
          text: "",
          value: "data-table-expand",
          align: "right",
          width: "50px",
          sortable: false
        },
      ],
      type: "add",
      client: false,
      today: null,
      complainOptions: [
        {
          id: "itch",
          name: "Jeuk"
        },
        {
          id: "wrongPlacement",
          name: "Verkeerde plaatsing"
        },
        {
          id: "qualityHair",
          name: "Kwaliteit haar"
        },
        {
          id: "tangles",
          name: "Klitten"
        },
        {
          id: "tuftLoss",
          name: "Plukverlies"
        },
        {
          id: "cut",
          name: "Snijden"
        },
        {
          id: "visibility",
          name: "Zichtbaarheid"
        },
        {
          id: "discoloration",
          name: "Verkleuring"
        },
        {
          id: "Other",
          name: "Overig"
        },
      ],
      removeComplainData: {
        id: null,
        dialog: false,
      },
      previewMembershipDialog: false,
      previewMembership: new Object(),
      requiredRules: [v => !!v || "Dit veld is verplicht"],
      membershipTypes: [
        {
          id: "new",
          name: 'Nieuw (3 maanden)'
        },
        {
          id: "extension",
          name: 'Verlenging (3 maanden)'
        },
        {
          id: "newFour",
          name: 'Nieuw (4 maanden)'
        },
        {
          id: "extensionFour",
          name: 'Verlenging (4 maanden)'
        }
      ],
    }),

    created() {
      this.today = moment().format("YYYY-MM-DD")
      this.loadUserComp();
    },

    methods: {
      loadUserComp() {
        this.dataloaded = false;
        this.userDataLoaded = false;
        let userCompanies = this.userCompanies;
        this.companies = [];
        let counter = 0

        new Promise((resolve, reject)=>{
          this.userCompanies.forEach(company=>{
            db.collection("companies").doc(company).get()
              .then(doc => {
                let dossierPackage = _.indexOf(doc.data().packages, 'dossier')
                if (dossierPackage >= 0) {
                  let company = doc.data();
                  company.id = doc.id;
                  this.companies.push(company);
                }
                counter++
                if(counter == this.userCompanies.length){
                  resolve()
                }
              })
          })
        })
        .then(()=>{
          // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
          if(this.userRole == 'superadmin'){
            // Super Admins have access to multiple companies 
            let selectedCompany = window.localStorage.getItem('selectedCompany')

            // Check if a selected company is set in the Local Storage
            if(selectedCompany){
              
              // Check if the selected company is an option
              let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

              // Selected company is an option, set activeComp
              if(selectedCompanyIndex >= 0){
                this.activeCompData = this.companies[selectedCompanyIndex];
                this.activeComp = this.companies[selectedCompanyIndex].id;
                this.loadComplainFormData();
                this.userDataLoaded = true;
              } 
              // Selected company is no option, set first company as activeComp 
              else{
                this.activeCompData = this.companies[0];
                this.activeComp = this.companies[selectedCompanyIndex].id;
                window.localStorage.setItem('selectedCompany', this.companies[0].id)
                this.loadComplainFormData();
                this.userDataLoaded = true;
              }
            }
            // No selected company is set 
            else {
              this.activeCompData = this.companies[0];
              this.activeComp = this.companies[selectedCompanyIndex].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadComplainFormData();
              this.userDataLoaded = true;
            }
          }

          // Regular users have 1 company, just get the first
          else {
            this.activeCompData = this.companies[0];
            this.activeComp = this.companies[0].id;
            this.loadComplainFormData();
            this.userDataLoaded = true;
          }
        })
      },

      viewComplain(item){
        bus.$emit("openComplainDialog" , null, 'view', item);
      },
  
      loadBranches() {
        if(this.companies.length > 1){
          this.companies.forEach(company => {
            if(company.id == this.activeComp){
              this.activeCompData = company;
            }
          });
        }
        
        db.collection("branches")
        .where("compId", "==", this.activeComp)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let branchCollection = doc.data();
            branchCollection.id = doc.id;
            this.branches.push(branchCollection);
          });
        })
      },

      addNewComplain(){
        bus.$emit("openComplainDialog", null, "add", null);
      },

      getBranchName(branche){
        let name = '';
        this.branches.forEach(element => {
          if(element.id == branche){
            name = element.branchName
          }
        });
        return name;
      },

      deleteComplainDialog(item){
      this.removeComplainData.id = item.id;
      this.removeComplainData.dialog = true;
    },

      closeRemoveComplain(){
        this.removeComplainData.dialog = false;
        this.removeComplainData.id = null;
      },

      async deleteMembership(){
     await db.collection("complains").doc(this.removeComplainData.id ).delete()
      .then(()=>{
        this.complains = this.complains.filter(item => {return item.id != this.removeComplainData.id})
      })
      this.closeRemoveComplain()
    },

      
      getBranchName(branch){
        let name = null;
        this.branches.forEach(option=>{
          if(option.id == branch){
            name = option.branchName;
          }
        })
        return name;
      },
      
      getComplainName(complain){
        let name = null;
        this.complainOptions.forEach(option=>{
          if(option.id == complain){
            name = option.name;
          }
        })
        return name;
      },


      updateData(){
        this.dataloaded = false;
        this.loadComplainFormData();
      },

      async loadComplainFormData(){
        this.loadBranches();
        await db.collection("complains")
        .where("companyId", "==", this.activeComp)
        .orderBy("date", "desc")
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let complain = doc.data();
            complain.id = doc.id;
            this.complains.push(complain);
          });
        })
        this.dataloaded = true;
      },

      updateData() {
        this.loadComplainFormData();
      },

      editClientQueueItem(item) {
        this.selectedClientQueueItem = Object.assign({}, item);
        this.selectedClientQueueItem.queueEndDatePicker  = moment.unix(item.queueEndDate.seconds).format("YYYY-MM-DD");
        this.selectedClientQueueItemOriginal = _.cloneDeep(this.selectedClientQueueItem);
        this.editQueueDialog = true;
      },

      setClientData(resultsSearch){
        this.complain.firstName = resultsSearch.firstname;
        this.complain.lastName = resultsSearch.middlename + " " + resultsSearch.lastname;
        this.newMedicalIntake.salonhubId = resultsSearch.id;
      },

      goToDossier(salonhubId){
        this.$router.push('/dossier?id='+ salonhubId)
      },
      formatDate(date) {
        // Datum omvormen naar Europese leesbare datum
        if (!date) return null;
        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      }
    },

    computed: {
      demoMode(){
        return this.$store.state.demoMode;
      },
      userCompanies() {
        return this.$store.state.userCompanies;
      },
      userBranches() {
        return this.$store.state.userBranches;
      }, 
      userCompany() {
        return this.$store.state.userCompany;
      },
      userFirstName() {
        return this.$store.state.userFirstName;
      },
      userLastName() {
        return this.$store.state.userLastName;
      },
      userRole() {
        return this.$store.state.userRole;
      },
      companyPrimaryColor() {
        return this.$store.state.companyPrimaryColor;
      },
      companySecondaryColor() {
        return this.$store.state.companySecondaryColor;
      },
      filteredCompanies(){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      },
      theme(){
        return (this.$vuetify.theme.dark) ? 'dark' : 'light'
      },
      complainDateFormatted() {
        // Datum omvormen naar Europese leesbare datum
        return this.formatDate(this.complain.date);
      },
      
      branchesChanged() {
        if (
          _.isEqual(this.selectedBranches, this.selectedBranchesOriginal) == false
        ) {
          return false;
        } else {
          return true;
        }
      },
      branchesWidth(){
        if(this.companies.length > 1 && !this.demoMode){
          return "md6"
        }
        else{
          return "md9"
        }
      }
    }
  };
</script>
<style>
.company-package{
  display: list-item;
  margin: 0;
}

.company-package-list{
  padding: 5px 0;
}
</style>
